import { useMutation } from '@tanstack/react-query';

import { API_VERSION_V2 } from '~/constants';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeUploadContractSignResponse = {
  code: string;
  message: string;
  data: {
    attachmentKey: string;
    fileExtension: string;
    id: number;
    originalName: string;
    presignedUrl: string;
    uuid: string;
  };
};

/** @description 계약서 서명 파일 업로드 */
export const useUploadContractSign = () => {
  const endpoint = '/labor/contract/sign';

  const REQUEST_CONTRACT_SIGN_TIMEOUT = 30 * 1000;

  const { mutateAsync } = useMutation({
    mutationFn: (params: FormData) => {
      return axiosInstance.post(endpoint, params, {
        timeout: REQUEST_CONTRACT_SIGN_TIMEOUT,
        headers: { version: API_VERSION_V2, 'Content-Type': 'multipart/form-data' },
      });
    },
  });

  const requestUploadContractSign = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: File;
    onSuccess: (response: TypeUploadContractSignResponse) => void;
    onError?: (error: TypeErrorFormat) => void;
  }) => {
    const formData = new FormData();
    formData.append('file', params, params.name);
    return requestHelper(() => mutateAsync(formData), onSuccess, onError);
  };

  return requestUploadContractSign;
};
